import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "config/config";
import getTimezone from "utils/getTimezone";

export const authenticationApi = createApi({
  reducerPath: "authenticationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${config.backApiBaseUrl}/v1/`,
    credentials: "include",
    headers: {
      Timezone: getTimezone(),
    },
  }),
  endpoints: (builder) => ({
    validateAuthentication: builder.query({
      query: () => 'settings/company_user/can_access_billing/',
    }),
    getBasicInformation: builder.query({
      query: () => 'settings/user_setting/get_tenant_info/',
    }),
  }),
});

export const {
  useValidateAuthenticationQuery,
  useGetBasicInformationQuery,
} = authenticationApi;
